export enum SwitchTypes {
  fiber = 'fiber',
  twistedPair = 'copper',
}
